<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/classes/index')">mdi-arrow-left</v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ساخت کلاس جدید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="onlineClass.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="دوره" :items="courses" item-text="title" item-value="id"
                      color="black" v-model="onlineClass.course_id">
            </v-select>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="آموزشگاه" :items="schools" item-text="label" item-value="id"
                      color="black" v-model="onlineClass.school_id">
            </v-select>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="مربیان" :items="teachers" multiple item-text="name" item-value="id"
                      color="black" v-model="onlineClass.instructors">
            </v-select>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="روز"
                      :items="[{text:'شنبه',value:1},{text:'یکشنبه',value:2},{text:'دوشنبه',value:3},{text:'سه شنبه',value:4},{text:'چهارشنبه',value:5},{text:'پنجشنبه',value:6},{text:'جمعه',value:7}]"
                      item-text="text" item-value="value"
                      color="black" v-model="onlineClass.day">
            </v-select>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" type="number" v-model="onlineClass.hour" label="ساعت"
                          hint="بین ۰ تا ۲۳ وارد شود"></v-text-field>
          </v-col>

          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" type="number" v-model="onlineClass.minute" label="دقیقه"
                          hint="بین ۰ تا ۶۰ وارد شود"></v-text-field>
          </v-col>

          <v-col cols="5" md="2" lg="2" sm="5">
            <v-text-field label="ظرفیت دوره" hint="عددی بین یک تا صد وارد شود"
                          color="black" v-model="onlineClass.capacity"></v-text-field>
          </v-col>

          <v-col cols="1" md="1" lg="1" sm="1">
            <v-checkbox
                label="موقت؟"
                v-model="onlineClass.is_temporary"
                color="black"
            >
            </v-checkbox>
          </v-col>

          <v-col cols="6" md="2" lg="2" sm="6">
            <vue-persian-datetime-picker color="black" v-model="onlineClass.start_date" custom-input="#start_date"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ شروع کلاس" v-model="onlineClass.start_date" id="start_date" color="black">
            </v-text-field>
          </v-col>

          <v-col cols="6" md="2" lg="2" sm="6">
            <vue-persian-datetime-picker color="black" v-model="onlineClass.pay_permission_date"
                                         custom-input="#pay_permission_date"
                                         auto-submit></vue-persian-datetime-picker>
            <v-text-field label="تاریخ اجازه پرداخت" v-model="onlineClass.pay_permission_date" id="pay_permission_date"
                          color="black">
            </v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field label="کاور"
                          @click="coverFileDialog = true" prepend-icon="mdi-plus"
                          color="black"
                          v-model="onlineClass.cover"></v-text-field>
          </v-col>

          <v-col cols="6" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="store()">ذخیره</v-btn>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn block color="warning" class="normal-font-btn" @click="clear()">پاک کردن</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="coverFileDialog" max-width="50vw">
      <drag-and-drop module="course" ref="image-uploader" @closeUploadFileDialog="coverFileDialog = false"
                     @changeFile="onlineClass.cover = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "OnlineClassCreate",
  components: {DragAndDrop, VuePersianDatetimePicker},
  data() {
    return {
      coverFileDialog: false,
      schools: [],
      courses: [],
      teachers: [],
      onlineClass: {
        title: null,
        school_id: null,
        course_id: null,
        day: null,
        is_temporary: false,
        hour: null,
        minute: null,
        capacity: null,
        start_date: null,
        pay_permission_date: null,
        cover: null,
        instructors: null
      }
    }
  },
  mounted() {
    this.getSchools()
    this.getCourses()
    this.getTeachers()
  },
  methods: {
    store() {
      window.axios.post('class/crud/create', this.onlineClass).then(() => {
        this.openSnackbar("کلاس جدید با موفقیت ساخته شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        } else {
          this.openSnackbar(err.message, '#F1416C')
        }
      })
    },
    clear() {
      this.onlineClass = {
        title: null,
        school_id: null,
        course_id: null,
        day: null,
        hour: null,
        minute: null,
        capacity: null,
        start_date: null,
        pay_permission_date: null,
        cover: null,
        is_temporary: false,
      }
    },
    getSchools() {
      window.axios.get('school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    },
    getCourses() {
      let url = '/course/crud/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.courses = res.data.data.data
      })
    },
    getTeachers() {
      let url = 'admin/instructor/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.teachers = res.data.data.data
      })
    },
  }
}
</script>

<style>
.back-link-icon {
  color: #413e3e !important;
}

.back-link-icon:hover {
  color: orangered !important;
}

.normal-font-btn {
  letter-spacing: normal !important;
}
</style>